module.exports = __webpack_public_path__ + "img/2019111403.27ea2da9.jpg";